import React from 'react';
import { List, Tooltip, Button } from 'antd';
import { ClockCircleOutlined, ClearOutlined, InboxOutlined } from '@ant-design/icons';
import { useSettingsState } from '../../../state/settingsState';
import styles from './StatusSidebar.module.css';

const RecentList = ({ history, pipelines, statuses, onStatusSelect }) => {
  const { clearHistory } = useSettingsState();
  const recentStatuses = history
    .map(id => statuses.find(s => s.amo_status_id === id))
    .filter(Boolean)
    .slice(0, 5);

  if (recentStatuses.length === 0) {
    return (
      <div className={styles.emptyState}>
        <InboxOutlined className={styles.emptyIcon} />
        <div className={styles.emptyText}>
          История пуста.<br />
          Выберите статусы для отображения здесь.
        </div>
      </div>
    );
  }

  const handleClearHistory = (e) => {
    e.stopPropagation();
    clearHistory();
  };

  return (
    <>
      <List
        size="small"
        dataSource={recentStatuses}
        renderItem={status => (
          <div className={styles.listItem}>
            <div 
              className={styles.listItemContent}
              onClick={() => onStatusSelect(status)}
            >
              <ClockCircleOutlined style={{ color: '#1890ff', fontSize: '12px' }} />
              <Tooltip title={`${pipelines[status.pipeline_id]?.name} → ${status.name}`}>
                <div className={styles.listItemText}>
                  {pipelines[status.pipeline_id]?.name} → {status.name}
                </div>
              </Tooltip>
            </div>
          </div>
        )}
      />
      {recentStatuses.length > 0 && (
        <div style={{ marginTop: '8px', textAlign: 'center' }}>
          <Button
            type="text"
            size="small"
            icon={<ClearOutlined />}
            onClick={handleClearHistory}
            style={{ 
              fontSize: '12px', 
              color: '#8c8c8c',
              height: 'auto',
              padding: '4px 8px'
            }}
          >
            Очистить историю
          </Button>
        </div>
      )}
    </>
  );
};

export default RecentList; 